module.exports = __webpack_public_path__ + "img/ws_SX.9e8ad6cc.png";